import { render, staticRenderFns } from "./ExtensionServiceTime.vue?vue&type=template&id=327aba58&scoped=true&"
import script from "./ExtensionServiceTime.vue?vue&type=script&lang=js&"
export * from "./ExtensionServiceTime.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionServiceTime.vue?vue&type=style&index=0&id=327aba58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327aba58",
  null
  
)

export default component.exports